import { BaseAPI, RequestMethod } from "../../../base";
import { ApiRoutes } from "../../../../../constants/api";
import { AuthTokenLoginRequestBody, AuthTokenLoginResponse } from "./types";

export class AuthTokenLoginAPI extends BaseAPI<
  AuthTokenLoginRequestBody,
  AuthTokenLoginResponse
> {
  protected route = ApiRoutes.auth.token_login;
  protected method = RequestMethod.POST;
}
